<template>
  <div class="checkout">
    <spinner v-if="asyncStatus.asyncDataLoading" size="5"></spinner>

    <card v-if="!asyncStatus.asyncDataLoading && product" class="container container-s">
      <template #title>
        <div class="width-expand text-center">
          <span>{{ translateTitleCase("justopp.bidClaim.cardTitle") }}</span>
        </div>
      </template>
      <template #default>
        <div class="text-center">
          <p class="text-center">
            {{ translateUcFirst("justopp.bidClaim.bidClaimExplain1") }}
          </p>
          <p class="text-center">
            {{ translateUcFirst("justopp.bidClaim.bidClaimExplain2") }}
          </p>
          <div
            class="flex gap-l flex-center flex-bottom margin-auto-horizontal margin-2xl-top">
            <form-input
              v-model="order.quantity"
              class="max-width-150"
              label="justopp.deal.selectQuantity"
              type="justoppUnits"
              :step-size="product.JustoppDealProductType.minimumQuantity"
              :minimum="product.JustoppDealProductType.minimumQuantity"
              :maximum="product.JustoppDealProductType.maximumQuantity"></form-input>
            <form-button
              v-if="hasSelectedQuantity"
              icon="refresh"
              theme="inverse"
              @click="startBidCheckoutByState">
              {{ translate("justopp.bidClaim.selectQuantityCtaAlreadySelected") }}
            </form-button>
            <form-button
              v-else
              icon-end="chevron-inline-end"
              @click="startBidCheckoutByState">
              {{ translate("justopp.bidClaim.selectQuantityCta") }}
            </form-button>
          </div>
          <div class="margin-s-top">
            <span>
              {{
                translateUcFirst("justopp.bidClaim.claimBidAvailableUnits", {
                  maximumQuantity: product.JustoppDealProductType.maximumQuantity,
                })
              }}
            </span>
          </div>

          <div
            v-if="hasSelectedQuantity"
            class="margin-2xl-top margin-auto-horizontal max-width-500">
            <h3>{{ translateTitleCase('justopp.bidClaim.finishClaimCtaTitle') }}</h3>
            <cart class="margin-auto-horizontal max-width-300" :cart="cart" read-only>
            </cart>
          </div>
        </div>
      </template>
    </card>

    <card
      v-if="!asyncStatus.asyncDataLoading && !product"
      title="justopp.bidClaim.cardTitle">
      <h3>{{ translateUcFirst("justopp.bidClaim.errorNoProduct") }}</h3>
    </card>
    <!--
    <card title="custom">
      <div class="flex gap-l">
        <div class="form">
          <form-input
            v-model="order.productId"
            type="text"
            label="product ID"></form-input>
          <form-input v-model="order.bidId" type="text" label="bid ID"></form-input>
          <form-input v-model="order.quantity" type="text" label="amount"></form-input>
          <form-button @click="startBidCheckoutByState">go</form-button>
        </div>
        <div class="cart">
          <cart :cart="cart" read-only> </cart>
        </div>
      </div>
    </card>
    <h1>bid checkout</h1>
    -->
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import useCarts from "@/client/extensions/composition/useCarts.js";
import Cart from "@/client/components/ecommerce/Cart.vue";
import { computed } from "vue";

export default {
  components: { Cart },
  layout: {
    component: "default",
    params: {
      title: "justopp.bidClaim.pageTitle",
    },
  },
  middleware: {
    requireUser: {},
  },
  props: {
    cartUuid: {
      type: [String],
      default: undefined,
    },
  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    let carts = useCarts(props);

    return { asyncOps, asyncOpsReady, asyncStatus, carts };
  },
  data: function () {
    const productId = this.$route.query?.productId; // 37
    return {
      cart: false,
      hasSelectedQuantity: false,
      order: {
        productId: productId, //37,
        bidId: this.$route.query?.bidId, // 45
        quantity: this.$route.query?.quantity, // 100
      },
      product: false,
      asyncData: {
        product: {
          target: "justopp/deals/" + productId,
          data: {},
          options: {
            dataMutator: (input) => {
              return input?.item;
            },
          },
        },
      },
    };
  },
  meta: "justopp.bidClaim.browserTitle",
  watch: {
    product(newVal) {
      if (newVal && ! this.$route.query?.quantity) {
        this.order.quantity = newVal.JustoppDealProductType.maximumQuantity;
      }
    },
  },
  async created() {
    this.cart = await this.carts.getCart(this.cartUuid);
    await this.cart.empty();
  },
  mounted() {},

  methods: {
    async startBidCheckoutByState() {
      this.hasSelectedQuantity = true;
      let cart = await this.carts.getCart();

      await cart.empty();
      let itemToAdd = {
        ProductId: this.order.productId,
        quantity: this.order.quantity,
        productConfig: {
          justoppDeal: {},
          auction: {
            userId: this.$store.getters["user/profile"].id,
            bidId: this.order.bidId,
          },
        },
      };
      console.log("start", itemToAdd);

      let addResult = await this.carts.addItem(itemToAdd, cart);

      if (!addResult) {
        this.$s.ui.notification("justopp.checkout.addToCartErrorNotification", "error");
        return false;
      }

      this.cart = await this.carts.getCart();
      //   this.$router.push({ name: "store-checkout", params: { locale: this.locale } });
    },
  },
};
</script>

<style scoped lang="scss"></style>
